import {
  Button,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { CaretDown } from "@phosphor-icons/react";
import React, { useEffect, useState } from "react";
import { CourseTema } from "../const/types";
import cr from "../lib/request";
import ComponentSpinner from "./spinner/ComponentSpinner";
import useTemaAllCourses from "../globalState/useTemaAllCourses";
import { useLocation } from "react-router-dom";
import useTemaMyCourses from "../globalState/useTemaMyCourses";

export default function TemaDropdown() {
  const [data, setData] = useState<CourseTema[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { tema, setTema } = useTemaAllCourses();
  const { myTema, setMyTema } = useTemaMyCourses();
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    setLoading(true);
    const url = `api/course/theme/alltheme`;
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Menu>
      <MenuButton
        as={Button}
        className="btn-solid"
        rightIcon={<Icon as={CaretDown} />}
        textAlign={"left"}
        flexShrink={0}
      >
        {path === "/mycourses"
          ? myTema?.theme_name || "Semua Tema"
          : tema?.theme_name || "Semua Tema"}
      </MenuButton>

      <MenuList>
        <MenuItem
          onClick={() => {
            if (path === "/mycourses") {
              setMyTema(null);
            } else {
              setTema(null);
            }
          }}
        >
          Semua Tema
        </MenuItem>

        {!loading && data ? (
          data.map((tema, i) => (
            <MenuItem
              key={i}
              onClick={() => {
                if (path === "/mycourses") {
                  setMyTema(tema);
                } else {
                  setTema(tema);
                }
              }}
            >
              {tema.theme_name}
            </MenuItem>
          ))
        ) : (
          <ComponentSpinner />
        )}
      </MenuList>
    </Menu>
  );
}
